// src/utils/mentions.js

// Token format we store in text when a mention is inserted:
//   @[Visible Name](u:123)
// This is easy to render and to extract ids from.

export const MENTION_TOKEN_RE = /@\[(.+?)\]\(u:(\d+)\)/g;

/** Extract unique user IDs from a body of text. */
export function extractMentionIds(text = "") {
  const ids = new Set();
  for (const m of text.matchAll(MENTION_TOKEN_RE)) {
    ids.add(Number(m[2]));
  }
  return Array.from(ids);
}

/** Render text with @[Name](u:id) tokens into JSX links to /profile/:id */
export function renderWithMentions(text = "", LinkComp) {
  if (!text) return text;

  const parts = [];
  let lastIndex = 0;
  for (const match of text.matchAll(MENTION_TOKEN_RE)) {
    const [full, name, id] = match;
    if (match.index > lastIndex) {
      parts.push(text.slice(lastIndex, match.index));
    }
    const key = `m-${match.index}-${id}`;
    // Allow react-router <Link> or fallback to <a>
    if (LinkComp) {
      parts.push(
        <LinkComp key={key} to={`/profile/${id}`} className="text-blue-600 hover:underline">
          @{name}
        </LinkComp>
      );
    } else {
      parts.push(
        <a key={key} href={`/profile/${id}`} className="text-blue-600 hover:underline">
          @{name}
        </a>
      );
    }
    lastIndex = match.index + full.length;
  }
  if (lastIndex < text.length) parts.push(text.slice(lastIndex));
  return parts.length ? <>{parts}</> : text;
}

/** Lightweight user search; returns array of {id, name, username, profile_pic_url} */
export async function searchUsers(api, q, token) {
  const headers = token ? { Authorization: `Bearer ${token}` } : undefined;
  const candidates = [
    `/users/search?q=${encodeURIComponent(q)}`,
    `/api/users/search?q=${encodeURIComponent(q)}`,
  ];
  for (const url of candidates) {
    try {
      const { data } = await api.get(url, { headers });
      if (Array.isArray(data)) return data;
    } catch (_) {}
  }
  return [];
}
